"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var dashboard_1 = require("./dashboard");
exports.DashboardService = dashboard_1.DashboardService;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/dashboard/services/index.js
// module id = 346
// module chunks = 0